import * as types from '../mutation-types-system'
import * as Routes from '~/lib/routes'
import Serializer from '~/lib/serializerSystem'
// import axios from 'axios'
import SystemClass from '~/lib/system'
import { buildWidthValues } from '~/lib/dimensionLimits'
// state
export const state = {
  system: null,
  loading: true,
  cLoading: false,
  name: null,
  dimension: null,
  availableWidth: null,
  totalPrices: [],
  discount: 0,
  price: {
    discounted: 0,
    total: 0
  },
  previewImagesLoading: true,
  previewImages: [],
  exampleImages: [],
  exampleImagesLoading: true,
  exampleImageIndex: null,
  animations: [],
  products: [],
  steps: [
    {
      id: null,
      visible: true,
      options: []
    }
  ],
  menu: [
    {
      id: null,
      name: null,
      sort: 0
    }
  ],
  currentStep: null,
  mailboxName: null,
  mainWidthDisplay: null,
  subOneWidthDisplay: null,
  subTwoWidthDisplay: null,
  pageTitle: '',
  metaDescription: '',
  description: ''
}
// getters
export const getters = {
  system: state => state.system,
  name: state => state.name,
  steps: state => state.steps,
  menu: state => state.menu,
  discount: state => state.discount,
  price: state => state.price,
  previewImagesLoading: state => state.previewImagesLoading,
  previewImages: state => state.previewImages,
  exampleImages: state => state.exampleImages,
  exampleImagesLoading: state => state.exampleImagesLoading,
  exampleImageIndex: state => state.exampleImageIndex,
  getMainImage: state => state.main_image,
  mailboxName: state => state.mailboxName,
  mainWidthDisplay: state => state.mainWidthDisplay,
  subOneWidthDisplay: state => state.subOneWidthDisplay,
  subTwoWidthDisplay: state => state.subTwoWidthDisplay,
  animations: state => state.animations,
  products: state => state.products,
  dimension: state => state.dimension,
  availableWidth: state => state.availableWidth,
  pageTitle: state => state.pageTitle,
  metaDescription: state => state.metaDescription,
  description: state => state.description,
  loading: state => state.loading,
  cLoading: state => state.cLoading,
  hasNextStep: (state) => {
    if (!state.currentStep && state.steps.length > 1) {
      return true
    }
    let found = false
    let hasNextStep = false
    state.steps.find(s => {
      if (found) {
        hasNextStep = true
        return true
      }
      found = s.id === state.currentStep
      return false
    })
    return hasNextStep
  },
  currentOptions: (state, getters) => {
    const currentStep = state.steps.find(step => step.id === state.currentStep) || state.steps.find(step => step.visible)
    return (currentStep.options || []).filter(step => step.visible)
  },
  currentStep: (state) => {
    return state.steps.find(step => step.id === state.currentStep) ||
      state.steps.find(step => step.visible)
  },
  totalPrice: (state) => ({ id }) => {
    return state.totalPrices.find(o => o.id === id)
  },
  getOptionsSelected: (state) => {
    if (state.system !== null) {
      return state.system.options[0].selected
    }
  },
  getFromMainConfig: (state) => {
    if (state.system !== null) {
      return state.system.getFromMainConfig()
    }
  },
  getFromSub1Config: (state) => {
    if (state.system !== null) {
      return state.system.getFromSub1Config()
    }
  },
  getFromSub2Config: (state) => {
    if (state.system !== null) {
      return state.system.getFromSub2Config()
    }
  },
  getBaseSubSteps: (state) => {
    if (state.system !== null) {
      return state.system.getBaseSubSteps()
    }
  },
  getFromSub3Config: (state, getters) => {
    if (state.system !== null) {
      return state.system.getFromSub3Config()
    }
  },
  getSelection: (state) => {
    if (state.system !== null) {
      return widthSelection(state.system.main)
    }
  },
  getBaseStepsOptions: (state) => {
    if (state.system !== null) {
      const stepId = state.system.config_main.steps[0]
      const step = state.system.main.steps.find(step => step.id === stepId)
      const array = {
        parent: [],
        child: []
      }
      step.options.forEach(option => {
        if (typeof option.show_for !== 'undefined') {
          array.child.push(option)
        } else {
          array.parent.push(option)
        }
      })
      return array
    }
  },
  getSelectionSubTwo: (state) => {
    if (state.system !== null) {
      return widthSelection(state.system.sub_2)
    }
  },
  getSelectionSubOne: (state) => {
    if (state.system !== null) {
      return widthSelection(state.system.sub_1)
    }
  },
  getTotalPrice: state => {
    if (state.system !== null) {
      void state.price
      return state.system.getTotalPrices()
    }
  },
  getOptionsPfosten: (state) => {
    if (state.system !== null) {
      return state.system.getOptionsConfig()
    }
  },
  getMetersFromConfigs: state => {
    if (state.system !== null) {
      return state.system.getMetersFromConfigs()
    }
  },
  summary: state => {
    const summary = state.system ? state.system.summary() : {}
    return {
      ...summary
    }
  },
  requestSummary: (state, getters) => {
    const totals = getters.getTotalPrice || { discounted: 0, price: 0 }
    const steps = (getters.steps || [])
      .filter(step => step.type !== 'total')
      .map(step => ({
        name: step.name,
        value: step.selectedLabel || '--',
        option: []
      }))

    return {
      id: state.system?.id,
      name: 'Individueller Zaun-Konfigurator',
      price: {
        discounted: totals.discounted || 0,
        old_price: totals.price || 0,
        total: totals.price || 0
      },
      steps
    }
  }
}
// mutations
export const mutations = {
  [types.SET_SYSTEM] (state, system) {
    state.system = system
  },
  [types.SET_NAME] (state, name) {
    state.name = name
  },
  [types.SET_DIMENSION] (state, dimension) {
    state.dimension = dimension
  },
  [types.SET_AVAILABLE_WIDTH] (state, availableWidth) {
    state.availableWidth = availableWidth
  },
  [types.SET_PREVIEW_IMAGES] (state, images) {
    state.previewImages = images
  },
  [types.SET_PREVIEW_IMAGES_LOADING] (state, status) {
    state.previewImagesLoading = status
  },
  [types.SET_EXAMPLE_IMAGES] (state, images) {
    state.exampleImages = images
  },
  [types.SET_EXAMPLE_IMAGES_LOADING] (state, status) {
    state.exampleImagesLoading = status
  },
  [types.SET_EXAMPLE_IMAGE_INDEX] (state, index) {
    state.exampleImageIndex = index
  },
  [types.SET_ANIMATIONS] (state, animations) {
    state.animations = animations
  },
  [types.SET_LOADING] (state, status) {
    state.loading = status
  },
  [types.SET_SYSTEM_LOADING] (state, status) {
    state.cLoading = status
  },
  [types.SET_STEPS] (state, steps) {
    state.steps = steps
  },
  [types.SET_CURRENT_STEP] (state, id) {
    state.currentStep = id
  },
  [types.SET_PRICE] (state, price) {
    state.price = price
  },
  [types.SET_LOADING_PRICE_ALL] (state, { status, option }) {
    state.totalPrices.find(o => o.id === option.id).loading = status
  },
  [types.SET_PRICE_ALL] (state, { price, option }) {
    Object.assign(state.totalPrices.find(o => o.id === option.id), price)
  },
  [types.SET_MENU] (state, menu) {
    state.menu = menu
  },
  [types.SET_PRODUCTS] (state, products) {
    state.products = products
  },
  [types.SET_NEXT_STEP] (state) {
    let step = null
    let found = false
    state.steps.find(s => {
      if (found) {
        step = s
        return true
      }
      found = s.id === state.currentStep || !state.currentStep
      return false
    })
    state.currentStep = step.id
  },
  [types.SET_MAILBOX_NAME] (state, mailbox) {
    state.mailboxName = mailbox
  },
  [types.SET_MAIN_WIDTH_DISPLAY] (state, width) {
    state.mainWidthDisplay = width
  },
  [types.SET_SUB_ONE_WIDTH_DISPLAY] (state, width) {
    state.subOneWidthDisplay = width
  },
  [types.SET_SUB_TWO_WIDTH_DISPLAY] (state, width) {
    state.subTwoWidthDisplay = width
  },
  [types.SET_PAGE_CONTENT] (state, content) {
    state.pageTitle = content.pageTitle || ''
    state.metaDescription = content.metaDescription || ''
    state.description = content.description || ''
  }
}
// actions
export const actions = {
  setSystem ({ commit, dispatch }, config) {
    const system = new SystemClass(config)
    console.log(system)
    // eslint-disable-next-line no-unused-vars
    let definition
    // eslint-disable-next-line no-cond-assign
    if (definition = Routes.definitionSystem()) {
      const serialize = new Serializer(system)
      serialize.deserialize(definition)
    }
    // init config
    system.initializeSystem()

    const baseModelStep = system.base.steps.find(step => step.model_step)
    const selectedBaseModel = baseModelStep?.options?.find(option => option.selected)
    if (selectedBaseModel) {
      system.selectOptionAll(selectedBaseModel)
    }

    if (config.special_text) {
      const specialText = typeof config.special_text === 'string'
        ? JSON.parse(config.special_text)
        : config.special_text
      commit('configurator/SET_SPECIAL_TEXT', specialText, { root: true })
    }

    commit(types.SET_SYSTEM, system)
    commit(types.SET_ANIMATIONS, config.base['image-manager'].animations || [])
    commit(types.SET_MENU, system.getStepMenu())
    commit(types.SET_STEPS, system.getSteps())
    commit(types.SET_NAME, system.base.name)
    commit(types.SET_DIMENSION, system.dimension)
    commit(types.SET_PAGE_CONTENT, {
      pageTitle: config.page_title || '',
      metaDescription: config.meta_description || '',
      description: config.description || ''
    })

    const products = state.system.products
    commit(types.SET_PRODUCTS, products)
    commit(types.SET_AVAILABLE_WIDTH, state.system.availableWidth)
    commit(types.SET_SYSTEM_LOADING, true)
    // default montage
    dispatch('checkout/setMontageCost', system.montage, { root: true })
    dispatch('checkout/setMontageStatus', false, { root: true })

    // build price all stuff
    system.base.steps.filter(s => s.price_all).forEach(s => {
      s.options.forEach(o => {
        state.totalPrices.push({
          id: o.id,
          discounted: 0,
          total: 0,
          loading: false
        })
      })
    })
    refreshLiveImages({ commit, state })
  },
  refreshImages (context) {
    refreshExampleImages(context)
  },
  setCurrentStep ({ commit, state }, id) {
    commit(types.SET_CURRENT_STEP, id)
    commit(types.SET_PRICE, state.system.getTotalPrices())
  },
  selectMainOption ({ commit, state }, option) {
    const system = state.system
    const baseModelStep = system.base.steps.find(step => step.model_step)
    if (baseModelStep?.options?.some(item => item.id === option.id)) {
      system.base.selectOption({ id: baseModelStep.id }, { id: option.id })
    }
    system.selectOptionAll(option)
    commit(types.SET_MENU, system.getStepMenu())
    commit(types.SET_STEPS, system.getSteps())
    commit(types.SET_PRICE, system.getTotalPrices())
    commit(types.SET_PREVIEW_IMAGES_LOADING, true)
    refreshLiveImages({ commit, state })
  },
  toggleOption ({ commit, state, getters }, option) {
    const system = state.system
    system.toggleOption(getters.currentStep, option)
    commit(types.SET_STEPS, system.getActiveSteps())
    commit(types.SET_PRICE, system.getTotalPrices())
    commit(types.SET_PREVIEW_IMAGES_LOADING, true)
    refreshLiveImages({ commit, state })
  },
  selectColor ({ commit, state }, color) {
    state.system.selectColorAll(color)
    commit(types.SET_MENU, state.system.getStepMenu())
    commit(types.SET_STEPS, state.system.getSteps())
    commit(types.SET_PRICE, state.system.getTotalPrices())
    commit(types.SET_PREVIEW_IMAGES_LOADING, true)
    refreshLiveImages({ commit, state })
  },
  setDimensionBase ({ commit, state, dispatch }, { type, value }) {
    state.system.setDimensionBase(type, value)
    commit(types.SET_DIMENSION, state.system.dimension)
    syncSystemState({ commit, state })
    syncMontageCost({ state, dispatch })
  },
  setDimension ({ commit, state, dispatch }, { type, value, config }) {
    state.system.setDimension(type, value, config)
    if (!config || config === 'base') {
      commit(types.SET_DIMENSION, state.system.dimension)
    }
    commit(types.SET_AVAILABLE_WIDTH, state.system.availableWidth)
    commit(types.SET_PRODUCTS, state.system.products)
    commit(types.SET_STEPS, state.system.getSteps())
    commit(types.SET_PRICE, state.system.getTotalPrices())
    syncMontageCost({ state, dispatch })
  },
  changeConfigShow ({ commit, state, dispatch }, config) {
    state.system.setConfigShow(config)
    state.system.calculateAmountProducts()
    syncSystemState({ commit, state })
    commit(types.SET_SYSTEM_LOADING, true)
    syncMontageCost({ state, dispatch })

    if (config.config === 'sub_3' && Number.parseInt(config.checked) === 0) {
      commit(types.SET_MAILBOX_NAME, null)
    }
  },
  changeConfigOptionsShow ({ state, dispatch }, value) {
    state.system.setQuantity(value)
    syncMontageCost({ state, dispatch })
  },
  setMainWidthDisplay ({ commit }, value) {
    commit(types.SET_MAIN_WIDTH_DISPLAY, value)
  },
  setSubOneWidthDisplay ({ commit }, value) {
    commit(types.SET_SUB_ONE_WIDTH_DISPLAY, value)
  },
  setSubTwoWidthDisplay ({ commit }, value) {
    commit(types.SET_SUB_TWO_WIDTH_DISPLAY, value)
  },
  setSubTwoQuantity ({ commit, state }, val) {
    state.system.setSubTwoQuantity(val)
    syncSystemState({ commit, state })
  },
  setMainOption ({ commit, state }, value) {
    state.system.setMainOptions(value)
    syncSystemState({ commit, state })
    refreshLiveImages({ commit, state })
  },
  setSubOneOption ({ commit, state }, value) {
    state.system.setSubOneOption(value)
    syncSystemState({ commit, state })
    refreshLiveImages({ commit, state })
  },
  setSubTwoOptions ({ commit, state }, value) {
    console.log('v', value)
    state.system.setSubTwoOption(value)
    syncSystemState({ commit, state })
    refreshLiveImages({ commit, state })
  },
  setSubThreeOptions ({ commit, state }, value) {
    state.system.setSubThreeOption(value)
    syncSystemState({ commit, state })
    commit(types.SET_MAILBOX_NAME, state.system.getMailboxName())
    refreshLiveImages({ commit, state })
  },
  setOptionsValue ({ commit, state }, value) {
    state.system.setOptionsValue(value)
    syncSystemState({ commit, state })
    commit(types.SET_MAILBOX_NAME, state.system.getMailboxName())
    refreshLiveImages({ commit, state })
  },
  setMontage ({ commit, state, dispatch }, value) {
    state.system.setMontageToBase(value)
    syncSystemState({ commit, state })
    // montage
    dispatch('checkout/setMontageStatus', value, { root: true })
  }
}
function syncSystemState ({ commit, state }) {
  commit(types.SET_AVAILABLE_WIDTH, state.system.availableWidth)
  commit(types.SET_PRODUCTS, state.system.products)
  commit(types.SET_STEPS, state.system.getSteps())
  commit(types.SET_PRICE, state.system.getTotalPrices())
}
function syncMontageCost ({ state, dispatch }) {
  state.system.setMontageCost()
  dispatch('checkout/setMontageCost', state.system.montage, { root: true })
}
function refreshLiveImages ({ commit, state }) {
  const images = state.system.getPreviewImages().map(item => ({
    config: item.config,
    images: (item.images || []).map(image => ({ ...image }))
  }))
  commit(types.SET_PREVIEW_IMAGES, images)
  commit(types.SET_PREVIEW_IMAGES_LOADING, false)
  refreshExampleImages({ commit, state })
}
function normalizeExampleImages (images) {
  return (images || []).map((image, index) => {
    if (typeof image === 'string') {
      return { path: image, sort: index }
    }
    if (image && typeof image.path === 'string') {
      return {
        path: image.path,
        sort: typeof image.sort === 'number' ? image.sort : index
      }
    }
    return null
  }).filter(Boolean)
}

function slugifyName (name) {
  return String(name || '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
}

function getExampleImagesForOption (configurator, optionId) {
  if (!configurator || !optionId) {
    return []
  }
  const steps = configurator.exampleImages || {}
  for (const stepId of Object.keys(steps)) {
    const optionImages = steps[stepId]?.[optionId]
    if (Array.isArray(optionImages) && optionImages.length) {
      return optionImages
    }
  }
  return []
}

function widthSelection (configurator) {
  const range = buildWidthValues(configurator)
  return range.values.map(value => ({
    value,
    label: `${value} ${range.unit}`,
    selected: value === range.current
  }))
}

function getSelectedModelOption (configurator) {
  const step = configurator?.steps?.find(item => item.model_step)
  return step?.options?.find(option => option.selected) || null
}

function refreshExampleImages ({ commit, state }) {
  commit(types.SET_EXAMPLE_IMAGES_LOADING, true)
  commit(types.SET_EXAMPLE_IMAGES, [])

  let exampleImages = []
  const system = state.system
  const selectedBase = getSelectedModelOption(system?.base)

  if (selectedBase && system?.main) {
    const mainStep = system.main.steps.find(step => step.model_step)
    const matchingMain = mainStep?.options?.find(option => {
      return slugifyName(option.name) === slugifyName(selectedBase.name)
    })

    if (matchingMain && mainStep) {
      if (!matchingMain.selected) {
        system.main.selectOption({ id: mainStep.id }, { id: matchingMain.id })
      }
      exampleImages = getExampleImagesForOption(system.main, matchingMain.id)
    }

    if (!exampleImages.length) {
      exampleImages = getExampleImagesForOption(system.base, selectedBase.id)
    }
  }

  if (!exampleImages.length && system?.main && typeof system.main.getExampleImages === 'function') {
    exampleImages = system.main.getExampleImages() || []
  }

  if (!exampleImages.length && system?.base && typeof system.base.getExampleImages === 'function') {
    exampleImages = system.base.getExampleImages() || []
  }

  commit(types.SET_EXAMPLE_IMAGES, normalizeExampleImages(exampleImages))
  commit(types.SET_EXAMPLE_IMAGES_LOADING, false)
}
